import { isShadowMode } from '@/config';

const appContainer = document.getElementById('sportsbook-app');
const MIN_TABLET_BREAKPOINT = 980;
const MAX_TABLET_BREAKPOINT = 1170;

const isLargeScreen = () => {
  let targetWidth = window.innerWidth;

  if (isShadowMode) {
    const target = appContainer?.shadowRoot?.host;
    if (target) {
      targetWidth = target.getBoundingClientRect().width;
    }
  }

  return targetWidth > 1679;
};

const isMobile = () => {
  let targetWidth = window.innerWidth;

  if (isShadowMode) {
    const target = appContainer?.shadowRoot?.host;
    if (target) {
      targetWidth = target.getBoundingClientRect().width;
    }
  }

  const match = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(Android)|(webOS)/i);
  //Fix for iPad pro
  if (targetWidth > 980 && match && (match.includes('iPad') || match.includes('Android')))
    return false;
  if (targetWidth <= 980) return true;

  return !!match;
};

const isTablet = () => {
  let targetWidth = window.innerWidth;

  if (isShadowMode) {
    const target = appContainer?.shadowRoot?.host;
    if (target) {
      targetWidth = target.getBoundingClientRect().width;
    }
  }

  const isTablet = targetWidth > MIN_TABLET_BREAKPOINT && targetWidth < MAX_TABLET_BREAKPOINT;

  return isTablet;
};

export { isTablet, isLargeScreen, isMobile };
